import * as React from 'react';
import { CenterView } from '../../containers';
import { AltoSpinningLoader } from '../../loaders';

export const LoadingEmptyState = () => {
  return (
    <CenterView>
      <AltoSpinningLoader
        accessibilityLabel="loading"
        testID="loading"
      />
    </CenterView>
  );
};
